import React, { Button, Component, useState } from "react";

// components
import Cookies from "universal-cookie";
import getLezioni from "../../services/getLezioni";
import getCorso from "../../services/getCorso";
import getChiusura from "../../services/getChiusura";
import getInsegnanti from "../../services/getInsegnanti";
import Utils from "../../utils/utils";
import moment from "moment";
import { Page, Text, View, Document, StyleSheet, Image } from "@react-pdf/renderer";
import { PDFViewer } from "@react-pdf/renderer";
import getCorsi from "../../services/getCorsi";

import NeroTrasparente from "../../images/loghi/nero_trasparente.png";

export default class PdfCorsoPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	removeDuplicates(array) {
		const ids = new Set();
		return array.filter(item => {
			if (ids.has(item.id)) {
				return false;
			}
			ids.add(item.id);
			return true;
		});
	}

	async componentDidMount() {
		const cookies = new Cookies();
		const username = cookies.get("username", { path: "/" });
		const token = cookies.get("token", { path: "/" });
		const currentCorso = cookies.get("currentCorso", { path: "/" });
		const dateFrom = cookies.get("dateFrom", { path: "/" });
		const dateTo = cookies.get("dateTo", { path: "/" });

		var dDateFrom = moment(dateFrom + " 00:00:00", "yyyy-MM-DD HH:mm:ss");
		var dDateTo = moment(dateTo + " 23:59:59", "yyyy-MM-DD HH:mm:ss");

		this.lezioni = await getLezioni(username, token);
		this.chiusura = await getChiusura(username, token);
		this.insegnanti = await getInsegnanti(username, token);
		this.corsi = await getCorsi(username, token);

		if (!currentCorso.includes(";")) {
			this.corso = await getCorso(username, token, currentCorso);

			this.lezioni = this.lezioni.filter(
				l => l.id_corso == currentCorso || l.altri_corsi.split(";").indexOf(currentCorso) != -1
			);

			this.lezioni = this.lezioni.filter(l => {
				var ll = moment(l.data, "yyyy-MM-DD HH:mm:ss");
				if (dateFrom != "" && ll < dDateFrom) return false;
				if (dateTo != "" && ll > dDateTo) return false;
				return true;
			});
		} else {
			let corsiFusione = currentCorso.split(";");
			let finalLezioni = [];
			let name = cookies.get("pdfUnione", { path: "/" });
			this.corso = { name };

			corsiFusione.forEach(c => {
				let lezioni = this.lezioni.filter(l => l.id_corso == c || l.altri_corsi.split(";").indexOf(c) != -1);

				lezioni = lezioni.filter(l => {
					var ll = moment(l.data, "yyyy-MM-DD HH:mm:ss");
					if (dateFrom != "" && ll < dDateFrom) return false;
					if (dateTo != "" && ll > dDateTo) return false;
					return true;
				});

				finalLezioni.push(...lezioni);
			});

			finalLezioni = this.removeDuplicates(finalLezioni);
			this.lezioni = [...finalLezioni];
		}

		this.lezioni.forEach((l, i) => {
			let altriInsegnanti = "";
			let arrInsegnanti = l.id_insegnanti ? l.id_insegnanti.split(",") : [];

			arrInsegnanti.forEach(temp => {
				if (!temp) return;
				let tempInsegnante = this.insegnanti.find(insegnante => insegnante.id == temp);
				if (tempInsegnante) {
					altriInsegnanti +=
						(altriInsegnanti ? ", " : "") + tempInsegnante.nome + " " + tempInsegnante.cognome;
				}
			});

			let altriCorsi = "";
			let arrAltriCorsi = l.altri_corsi ? l.altri_corsi.split(";") : [];
			arrAltriCorsi.forEach(t => {
				if (!t) return;
				let tempCorso = this.corsi.find(corso => corso.id == t);
				if (tempCorso) {
					altriCorsi += (altriCorsi ? ", " : "") + tempCorso.name;
				}
			});

			if (!currentCorso.includes(";") && this.corso && this.corso.name) {
				altriCorsi = altriCorsi.replace(new RegExp(`,?\\s*${this.corso.name}`, "g"), "").trim();
			}

			this.lezioni[i].altriInsegnanti = altriInsegnanti;
			this.lezioni[i].altriCorsi = altriCorsi;
		});

		this.lezioni = this.lezioni.sort((l1, l2) => {
			let ll1 = moment(l1.data, "YYYY-MM-DD HH:mm:ss");
			let ll2 = moment(l2.data, "YYYY-MM-DD HH:mm:ss");
			return ll1 - ll2;
		});

		this.mesi = [];
		this.coppieMesi = [];
		let tempMese = "";

		this.lezioni.forEach(l => {
			let ll = moment(l.data, "YYYY-MM-DD HH:mm:ss");
			let mmYYYY = ll.format("YYYY-MM");
			if (!this.mesi.includes(mmYYYY)) {
				this.mesi.push(mmYYYY);
				if (tempMese) {
					this.coppieMesi.push([tempMese, mmYYYY]);
					tempMese = "";
				} else {
					tempMese = mmYYYY;
				}
			}
		});

		if (tempMese) {
			this.coppieMesi.push([tempMese]);
		}

		this.setState({});
	}

	render() {
		return (
			<div style={{ width: "100%", height: "100%" }} key={Math.random()}>
				<PDFViewer style={{ width: "100%", height: "100%" }}>
					<Document>
						{this.coppieMesi &&
							this.coppieMesi.map(coppiaMesi => {
								var mese1 = coppiaMesi[0];
								var mese2 = coppiaMesi[1];
								var strMese1 = "";
								var strMese2 = "";

								var ggMese1 = [];
								var ggMese2 = [];

								var ll1 = mese1 && moment(mese1, "yyyy-MM");
								var ll2 = mese2 && moment(mese2, "yyyy-MM");

								var dataToDisplay = [];

								if (mese1) {
									strMese1 = Utils.capitalizeFirstLetter(
										moment(mese1, "yyyy-MM").format("MMMM YYYY")
									);
									var d = ll1.clone();
									d.day = 1;
									while (d.month() == ll1.month()) {
										ggMese1.push(moment(d).format("DD"));
										d = d.add(1, "days");
									}

									dataToDisplay.push({
										strMese: strMese1,
										mese: mese1,
										ll: ll1.clone(),
										ggMese: ggMese1,
									});
								}

								if (mese2) {
									strMese2 = Utils.capitalizeFirstLetter(
										moment(mese2, "yyyy-MM").format("MMMM YYYY")
									);

									var d = ll2.clone();
									d.set("date", 1);
									while (d.month() == ll2.month()) {
										ggMese2.push(moment(d).format("DD"));
										d = d.add(1, "days");
									}

									dataToDisplay.push({
										strMese: strMese2,
										mese: mese2,
										ll: ll2.clone(),
										ggMese: ggMese2,
									});
								}
								let timeNow = moment().format("yyyy-MM-DD HH:mm:ss");

								return (
									<Page
										size="A4"
										style={{ paddingTop: 60, paddingBottom: 50 }}
										orientation="landscape"
										wrap
									>
										<View style={{ marginTop: -60 }}>
											<Image
												style={{
													position: "absolute",
													top: 5,
													left: 10,
													width: "6%",
													height: "auto",
												}}
												src={{
													uri: NeroTrasparente,
													method: "GET",
													headers: {},
													body: "",
												}}
											/>

											<Text
												style={{
													position: "absolute",
													top: 10,
													right: 10,
													fontSize: 14,
													width: "100%",
													textAlign: "right",
												}}
											>
												{timeNow}
											</Text>
											<Text
												style={{
													margin: 10,
													fontSize: 30,
													width: "100%",
													textAlign: "center",
												}}
											>
												{this.corso.name}
											</Text>

											<View style={styles.page}>
												{dataToDisplay.map(currentData => {
													return (
														<View style={{ flexDirection: "column", width: "50%" }}>
															<Text
																style={{
																	marginBottom: "0px",
																	fontSize: 10,
																	fontWeight: "bold",
																}}
															>
																{currentData.strMese}
															</Text>
															{currentData.ggMese.map(gg => {
																var d = currentData.ll.clone();
																d.set("date", parseInt(gg));
																var weekEnd = false;
																if (d.isoWeekday() == 7 || d.isoWeekday() == 6)
																	weekEnd = true;
																var strNumberAndDay =
																	gg +
																	" " +
																	d
																		.format("dddd")
																		.substr(0, 1)
																		.toUpperCase();

																var lezioniGiorno = this.lezioni.filter(l => {
																	var lM = moment(
																		l.data,
																		"yyyy-MM-DD HH:mm:ss"
																	).format("yyyy-MM");
																	var lD = moment(
																		l.data,
																		"yyyy-MM-DD HH:mm:ss"
																	).format("DD");
																	return currentData.mese == lM && gg == lD;
																});

																if (lezioniGiorno.length === 0) return null;

																var flagChiusura = false;
																this.chiusura.forEach(c => {
																	var chiusura = moment(
																		c.day,
																		"DD-MM-yyyy HH:mm:ss"
																	).format("yyyy-MM-DD");
																	var strTemp = moment(d).format("yyyy-MM-DD");
																	if (chiusura == strTemp) flagChiusura = true;
																});

																return (
																	<View style={styles.row} wrap={false}>
																		<Text
																			style={{
																				flexDirection: "column",
																				padding: 1,
																				width: "7%",
																			}}
																		>
																			{strNumberAndDay}
																		</Text>
																		<View
																			style={
																				weekEnd && lezioniGiorno.length != 0
																					? styles.weekEndOrangeDay
																					: weekEnd || flagChiusura
																					? styles.weekEndDay
																					: styles.weekDay
																			}
																		>
																			{flagChiusura ? (
																				<Text style={{ fontSize: 6 }}>
																					CHIUSURA SCUOLA
																				</Text>
																			) : (
																				lezioniGiorno.map(l => {
																					var orario = moment(
																						l.data,
																						"yyyy-MM-DD HH:mm:ss"
																					).format("HH:mm");
																					var orarioFine = moment(
																						l.data,
																						"yyyy-MM-DD HH:mm:ss"
																					)
																						.add(l.durata, "minutes")
																						.format("HH:mm");

																					return (
																						<Text
																							key={Math.random()}
																							style={{ fontSize: 6 }}
																						>
																							{orario +
																								" - " +
																								orarioFine +
																								" " +
																								l.str_corso}{" "}
																							{this.corso.name !==
																								l.str_corso &&
																								"- " + l.str_corso}{" "}
																							{l.altriCorsi !== "" &&
																								"- " + l.altriCorsi}
																						</Text>
																					);
																				})
																			)}
																		</View>
																	</View>
																);
															})}
														</View>
													);
												})}
											</View>
										</View>
									</Page>
								);
							})}
					</Document>
				</PDFViewer>
			</div>
		);
	}
}

const styles = StyleSheet.create({
	row: {
		flexDirection: "row",
		border: "1 solid #000",
		width: "90%",
	},
	page: {
		flexDirection: "row",
		backgroundColor: "#E4E4E4",
		fontSize: 8,
		backgroundColor: "#ffffff",
		padding: 10,
	},
	section: {
		margin: 10,
		padding: 10,
		flexGrow: 1,
	},
	weekEndOrangeDay: {
		borderLeft: "1 solid #000",
		flexDirection: "column",
		padding: 2,
		width: "93%",
	},
	weekEndDay: {
		borderLeft: "1 solid #000",
		flexDirection: "column",
		padding: 2,
		width: "93%",
	},
	weekDay: {
		borderLeft: "1 solid #000",
		flexDirection: "column",
		padding: 2,
		width: "93%",
	},
});
